import { useAuth, UserRole } from '../context/AuthContext';
import { Navigate } from 'react-router';
import { ShieldAlert } from 'lucide-react';

interface RoleGuardProps {
  allowedRoles: UserRole[];
  children: React.ReactNode;
}

export function RoleGuard({ allowedRoles, children }: RoleGuardProps) {
  const { user, isAuthLoading } = useAuth();

  if (isAuthLoading) {
    return null;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(user.role)) {
    return (
      <div
        className="flex flex-col items-center justify-center p-12"
        style={{ minHeight: '60vh', fontFamily: 'var(--font-family-inter)' }}
      >
        <div
          className="flex items-center justify-center"
          style={{
            width: '64px',
            height: '64px',
            borderRadius: '50%',
            backgroundColor: 'var(--error-muted)',
            color: 'var(--error)',
            marginBottom: '24px',
          }}
        >
          <ShieldAlert size={32} />
        </div>
        <h2
          style={{
            fontWeight: 'var(--font-weight-semibold)',
            fontSize: 'var(--text-lg)',
            color: 'var(--foreground)',
            marginBottom: '8px',
          }}
        >
          Acesso Negado
        </h2>
        <p
          style={{
            color: 'var(--muted-foreground)',
            fontSize: 'var(--text-sm)',
            textAlign: 'center',
            maxWidth: '400px',
            marginBottom: '24px',
            lineHeight: '1.5',
          }}
        >
          Seu perfil <strong style={{ color: 'var(--foreground)' }}>({user.role})</strong> nao tem
          permissao para acessar esta pagina. Entre em contato com o administrador se acredita que
          isso e um erro.
        </p>
        <a
          href="/"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            padding: '10px 20px',
            backgroundColor: 'var(--primary)',
            color: 'var(--primary-foreground)',
            borderRadius: 'var(--radius-button)',
            textDecoration: 'none',
            fontSize: 'var(--text-sm)',
            fontWeight: 'var(--font-weight-medium)',
          }}
        >
          Voltar ao Dashboard
        </a>
      </div>
    );
  }

  return <>{children}</>;
}
